import { useState } from "react";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/errors";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

export default function ChangePasswordDialog({ open, onOpenChange }) {
  const [lama, setLama] = useState("");
  const [baru, setBaru] = useState("");
  const [konfirmasi, setKonfirmasi] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const reset = () => { setLama(""); setBaru(""); setKonfirmasi(""); setError(""); };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (baru.length < 8) { setError("Kata sandi baru minimal 8 karakter."); return; }
    if (baru !== konfirmasi) { setError("Konfirmasi kata sandi tidak cocok."); return; }
    setSaving(true);
    try {
      await api.post("/auth/change-password", { password_lama: lama, password_baru: baru });
      toast.success("Kata sandi berhasil diubah");
      reset();
      onOpenChange(false);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || "Gagal mengubah kata sandi.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) reset(); onOpenChange(v); }}>
      <DialogContent className="max-w-sm" data-testid="change-password-dialog">
        <DialogHeader>
          <DialogTitle>Ubah Kata Sandi</DialogTitle>
          <DialogDescription>Masukkan kata sandi lama dan kata sandi baru Anda.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-1.5">
            <Label htmlFor="pw-lama">Kata Sandi Lama</Label>
            <Input id="pw-lama" type="password" required value={lama}
              onChange={(e) => setLama(e.target.value)} data-testid="old-password-input" className="h-10" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="pw-baru">Kata Sandi Baru</Label>
            <Input id="pw-baru" type="password" required value={baru}
              onChange={(e) => setBaru(e.target.value)} placeholder="Minimal 8 karakter"
              data-testid="new-password-input" className="h-10" />
          </div>
          <div className="space-y-1.5">
            <Label htmlFor="pw-konfirmasi">Konfirmasi Kata Sandi Baru</Label>
            <Input id="pw-konfirmasi" type="password" required value={konfirmasi}
              onChange={(e) => setKonfirmasi(e.target.value)} data-testid="confirm-password-input" className="h-10" />
          </div>
          {error && <p className="text-sm text-rose-600 font-medium" data-testid="change-password-error">{error}</p>}
          <DialogFooter className="gap-2">
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}
              data-testid="change-password-cancel">Batal</Button>
            <Button type="submit" disabled={saving} data-testid="change-password-submit"
              className="bg-blue-600 hover:bg-blue-700 text-white transition-colors">
              {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Simpan"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
